/* src/app/components/payroll/timesheets/mass-adjustments/add-mass-adjustment/add-mass-adjustment.component.css */
.details-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
ppl-accordion {
  display: block;
  width: 100%;
}
.ppl-content-container {
  overflow-x: hidden;
}
.body-scroll {
  padding: 8px;
  max-height: calc(100vh - 140px);
  box-sizing: border-box;
}
.wiz-body {
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  padding: 12px;
}
.section-label {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}
.section-label-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
.input-section {
  width: 100%;
  transition: opacity 0.3s ease;
}
.disabled-section {
  opacity: 0.4;
  pointer-events: none;
}
.or-divider {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 20px 0;
}
.or-divider::before,
.or-divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #d9d9d9;
}
.or-divider-text {
  padding: 0 16px;
  font-size: 14px;
  font-weight: 600;
  color: #8c8c8c;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.adjustment-section {
  width: 100%;
  margin-top: 16px;
  border-top: 1px solid #d9d9d9;
  padding-top: 16px;
}
.table-wrapper {
  width: 100%;
}
.criteria-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.col-field {
  width: 25%;
  padding-left: 10px;
}
.col-actions {
  width: 15%;
  padding-left: 10px;
}
.cell {
  vertical-align: middle;
  padding: 10px;
}
.cell-actions {
  white-space: nowrap;
}
.action-btn {
  margin-right: 4px;
}
.action-btn-danger {
  color: #d32f2f;
}
.full-width {
  width: 100%;
}
nz-date-picker.full-width {
  padding: 0 8px;
}
.validation-error {
  display: block;
  color: #d32f2f;
  font-size: 12px;
  margin-top: 4px;
}
.auth-adjustment-grid {
  width: 100%;
}
::ng-deep .auth-adjustment-grid .ant-picker-input > input {
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  padding: 0 8px;
}
::ng-deep .auth-adjustment-grid .auth-participant-id {
  border-radius: 2px !important;
}
.auth-picker-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.auth-picker-row nz-select,
.auth-picker-row ppl-dropdown-select {
  flex: 1;
  min-width: 0;
}
.auth-search-btn {
  flex-shrink: 0;
  color: #1890ff !important;
}
.auth-search-btn:disabled {
  color: #bfbfbf !important;
}
.auth-hint {
  display: block;
  font-size: 11px;
  color: #8c8c8c;
  margin-top: 4px;
}
/*# sourceMappingURL=add-mass-adjustment.component-Q4N2QWWZ.css.map */
